<template>
    <div>
        <div class="login-page container">
        <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>

        <div class="is-centered">
            <div class="card-container">
                <img :src="logoBase64Src" class="center" v-show="logo">
                <h1 class="title">{{ loginText }}</h1>
                <div class="login-container">
                        <p class="has-text-danger" v-if="$route.query.redirect">
                        You need to login first.
                        </p>
                        <form class="login-form" @submit.prevent="login">
                            <b-field label="Username">
                                <b-input type="text" placeholder="Email or username" v-model="username"></b-input>
                            </b-field> 
                            <b-field label="Password">
                                <b-input type="password" placeholder="Password" v-model="password"></b-input>
                            </b-field> 
                            <div class="field is-grouped horizontal-stack">
                                <div class="control">
                                    <button class="button is-success is-medium horizontal-block">Login</button>
                                </div>
                                <div class="control">
                                    <router-link class="button is-text is-medium horizontal-block" :to="{name: 'resetPassword'}">Reset Admin Password</router-link>
                                </div>
                                <div class="control">
                                    <router-link class="button is-text is-medium horizontal-block" :to="{name: 'resetUsername'}">Reset Admin Username</router-link>
                                </div>
                            </div>
                            <div class="vertical-stack">
                                <button class="vertical-block button is-success is-large">Login</button>
                                <router-link class="vertical-block button is-light is-large" :to="{name: 'resetPassword'}">Reset Admin Password</router-link>
                                <router-link class="vertical-block button is-light is-large" :to="{name: 'resetUsername'}">Reset Admin Username</router-link>
                            </div>
                        </form>
                </div>
            </div>
            </div>
        </div>
        <copyright-footer></copyright-footer>
    </div>
</template>

<script>
import loginAPI from '@/api/LoginAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'
import CopyrightFooter from '@/components/CopyrightFooter.vue'

export default {
    name: 'Login',

    props: ['usernameProp'],

    components:{
        "copyright-footer": CopyrightFooter
    },

    data () {
        return {
            username: null,
            password: null,
            hash: null,
            errorMsg: null,
            isLoading: false,
            isFullPage: true,
            notificationDuration: 4000,
        }
    },

    created() {
        if( this.usernameProp ){
            this.username = this.usernameProp;
        }
        //Allow email and hash to be passed via query params.
        var hash = this.$route.query.hash;
        var email = this.$route.query.email;
        if( hash !== undefined){
            this.hash = hash;
            this.password = hash;
            this.username = email;
        };
        if(this.$route.query.redirect){
            console.log(this.$route.query.redirect)
            store.commit('setSlug', this.$route.query.redirect.substring(1))
        }
        else if(this.$route.params.slug){
            store.commit('setSlug', this.$route.params.slug)
        }
        else{
            store.commit('setSlug', null)
        }

        if(this.slug != null && this.slug != undefined){
            this.loadLogo();
            // this.loadAddress();
        }
       

    },
    computed: {
        logoBase64Src: function(){
            if (this.logo !="" && this.logo != null && this.logo !=undefined && Object.keys(this.logo).length != 0){
                return "data:image/jpg;base64, " + this.logo
            }
            
        },


        ...mapState([
            'logo',
            'address',
            'slug',
            'userInfo'
        ]),


        loginText: function(){
            if (Object.keys(this.address).length != 0 && Object.keys(this.logo).length != 0){
                return "Login"
            }
            else if(Object.keys(this.address).length != 0 && Object.keys(this.logo).length == 0){
                return this.address.name + " Login"
            }
            else{
                return "Login"
            }
        },


        websiteURL: function(){
            if(this.slug != null || this.slug != undefined){
                var url = this.address.website;
                var substringURL = url.substring(0,4);

                if ( substringURL != "http"){
                    return "http://" + url
                }
            }
            else{
                return null;
            }
        },


        flagAddressExists: function(){
            if (this.address != null && Object.keys(this.address).length != 0 && this.address != undefined){
                return true
            }
            else{
                return false
            }
        }
    },

    methods: {
         ...mapMutations([
            'setExistingPassword',
            'setSlug',
            'setLogo',
            'setAddress'
        
         ]),


         //LOGS USER IN
        login: async function(){
            this.isLoading = true
            loginAPI.login(this.username, this.password, this.hash, this.slug, response => {
                if (response.authenticated != true) {
                    self.errorMsg = response.errorMsg;
                    self.error = true;
                    store.commit('setUserData', {});
                    this.$snotify.error(  self.errorMsg, "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                    
                    this.isLoading = false
                } 
                else {
                    this.isLoading = false
                    store.commit('setUserData', response.user);
                    var scriptParameters = `{
                        "counterType" : "login",
                        "userID": "${response.user.userID}"
                    }`;
                    if( response.user.isPasswordChangeNeeded ){
                        // this.isLoading = false
                        store.commit('setExistingPassword', this.password)
                        this.$router.push({ name: 'changePasswordNeeded', params: { userID: response.user.userID, recID: response.user.recID}})
                    }
                    else if( response.user.isUsernameChangeNeeded){
                        this.$router.push({ name: 'changeUsernameNeeded', params: { userID: response.user.userID, recID: response.user.recID}})
                    }
                    else if(this.$route.query.redirect){
                        // this.isLoading = false
                        this.$router.replace( this.$route.query.redirect)
                    }
                    else{
                        // this.isLoading = false
                        this.$router.replace({ name: 'home'})
                    }

                    this.countLogin(scriptParameters);
                }
            });
        },

        
        /**
         * LOADS LOGO FROM FILEMAKER TO LOGIN SCREEN
         */
        loadLogo: async function(){
            this.isLoading = true
            var findResults
            try{ findResults = await loginAPI.loadLogo(this.slug) }
            catch(err){
                store.commit('setLogo', null)
                if(findResults.messages[0].code == "401" || valueLists.messages[0].code == "Operation timed out after 30000 milliseconds with 0 bytes received"){
                    this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please log out and try again.", "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                return
                }

                if(findResults.messages[0].code != "0"){
                    this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please log out and try again.", "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                return
                }
            }
            store.commit('setLogo', findResults)
            this.isLoading = false
        },


        /**
         * LOADS ADDRESS FROM FILEMAKER TO LOGIN SCREEN
         */
        loadAddress: async function(){
            this.isLoading = true
            var findResults
            try{ findResults = await loginAPI.loadAddress(this.slug) }
            catch(err){
                store.commit('setAddress', null)
                if(findResults.messages[0].code == "401" || valueLists.messages[0].code == "Operation timed out after 30000 milliseconds with 0 bytes received"){
                    this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please log out and try again.", "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                return
                }

                if(findResults.messages[0].code != "0"){
                    this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please log out and try again.", "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                return
                }
            }
            store.commit('setAddress', findResults)
            this.isLoading = false
        },


        /**
        * ADDS A COUNT TO THE USER LOGGING IN
        */
        countLogin: async function(scriptParameters){
            const result = sharedAPI.runScript("User - Update Counters", scriptParameters)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-page{
        min-height: 475px;
    }
    .login-container{
        vertical-align: text-top;
    }
    .address-container{
        display: inline-block;
        width: 35%;
        padding: 0px 0px 0px 5px;
        margin: 0px;
        vertical-align: top;
    }

    .login-form-container{
        display: inline-block;
        width: 60%;
        padding: 0px 5px 0px 0px;
        margin: 0px;
    }
    .has-text-danger {
        padding-bottom: 20px;
    }
    .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .card-container {
        padding: 2rem;
        margin: 0px 20px 20px 20px;
    }
    .logo {
        width: 20%;
        height: 20%;
    } 
    .left{
        float: left !important;
    }
    .right{
        float: right !important;
    }
    .verticalLine {
        border-left: 2px solid #a9a9a9;
        height: 75%;
    }

    .horizontal-stack{
        display: block;
    }

    .vertical-stack{
        display:none;
    }

    .footer-banner{
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media only screen and (max-width: 680px){
        .horizontal-stack{
            display: none;
        }

        .horizontal-block{
            display: none;
        }

        .vertical-stack{
            display: block;
        }

        .vertical-block{
            display: block;
            width: 100%;
            margin-bottom: 15px;
        }
    }

  /*.field-container {*/
  /*  background-color: #FFFFFF;*/
  /*  border: solid 1px #cccccc;*/
  /*  border-radius: 5px;*/
  /*  padding: 2rem;*/
  /*  margin: 0px 20px 20px 20px;*/
  /*}  */
</style>
